// extracted by mini-css-extract-plugin
module.exports = {"closeAlertButton":"EGiftCard_closeAlertButton__wn1za","imageUploader":"EGiftCard_imageUploader__1ym8m"};